import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'GoogleCodeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    labelWidth: {
      type: String,
      default: '100px'
    }
  },
  data: function data() {
    var validateGoogleCode = function validateGoogleCode(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入Google验证码'));
      }
      if (!/^\d{6}$/.test(value)) {
        return callback(new Error('Google验证码应为6位数字'));
      }
      callback();
    };
    return {
      formData: {
        googleCode: ''
      },
      rules: {
        googleCode: [{
          validator: validateGoogleCode,
          trigger: 'blur'
        }]
      }
    };
  },
  watch: {
    visible: function visible(val) {
      if (val) {
        this.resetForm();
      }
    }
  },
  methods: {
    resetForm: function resetForm() {
      this.formData.googleCode = '';
      if (this.$refs.googleForm) {
        this.$refs.googleForm.clearValidate();
      }
    },
    handleClose: function handleClose() {
      this.$emit('close');
    },
    handleCancel: function handleCancel() {
      this.resetForm();
      this.$emit('cancel');
    },
    handleConfirm: function handleConfirm() {
      var _this = this;
      if (!this.$refs.googleForm) return;
      this.$refs.googleForm.validate(function (valid) {
        if (valid) {
          _this.$emit('confirm', _this.formData.googleCode);
        }
      });
    }
  }
};